'use strict';

const HtmlClass = {
	render(){
		if( app.Util.ua() ) app.html.classList.add(app.Util.ua());
		if( app.Util.ua() == 'ie10' || app.Util.ua() == 'ie11' ) app.html.classList.add('isIE');
		if( app.Util.isMS() ) app.html.classList.add('isMS');
		if( !app.Util.touch() ) app.html.classList.add('notouch');
		this.resizing();
	},

	// リサイズ中だけ html に is-resizing を付ける。
	// CSS 側（_foundation/_base.scss）で transition を無効化するためのフラグ。
	// 解除は 200ms 後。app.Util.resize() のデバウンスが 100ms なので、
	// 各所の再計算（ヘッダーのナビ下線など）が終わってから transition を戻す。
	resizing(){
		let timerID;
		window.addEventListener('resize', ()=>{
			app.html.classList.add('is-resizing');
			clearTimeout(timerID);
			timerID = setTimeout(()=>{
				app.html.classList.remove('is-resizing');
			}, 200);
		});
	}
};

export default HtmlClass;
